import axios from 'axios';
import Multiselect from 'vue-multiselect';
import showAlert from '../alert/alertHandler';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import SimpleMap from '@/components/global/simple-map/SimpleMap.vue';
import RouteDetailMapV2 from '../components/RouteDetailMapV2.vue';
import moment from 'moment';

import spotFormEscl from '../locales/es-CL/spotForm.json';
import spotFormEsmx from '../locales/es-MX/spotForm.json';
import spotFormEsco from '../locales/es-CO/spotForm.json';
import spotFormEnus from '../locales/en-US/spotForm.json';
import LogService from '../services/LogService';
import Container from 'typedi';

export default {
  name: 'SpotForm',
  props: ['optionSpots', 'onlyDefinitiveSpots', 'gapi', 'selectedSpot'],
  components: {
    Multiselect,
    GoogleMapsApiLoader,
    BuscadorDirecciones,
    SimpleMap,
    RouteDetailMapV2,
  },
  i18n: {
    messages: {
      'es-CL': {
        spotForm: spotFormEscl,
      },
      'es-MX': {
        spotForm: spotFormEsmx,
      },
      'es-CO': {
        spotForm: spotFormEsco,
      },
      'en-US': {
        spotForm: spotFormEnus,
      },
    },
  },
  data() {
    return {
      newDepot: null,
      spotDefinitiveChecked: false,
      temporalSpotRequired: false,
      isTemporalSpotBusy: false,
      spotTypeList: [],
      countryList: [],
      businessList: [],
      dataAccess: null,
      spotTypeSelected: null,
      businessSelected: null,
      countrySelected: null,
      countrySelectedName: null,
      isInputUsed: false,
      isCityEmpty: false,
      isStateEmpty: false,
      checkFields: {
        address: true,
        country: true,
        state: true,
        city: true,
        name: true,
        type: true,
        numberId: true,
      },
      spotForm: {
        id: null,
        address: {
          id: null,
          city: null,
          addressComplement: null,
          postalCode: null,
          state: null,
          street: '',
          lat: null,
          lon: null,
          country: {
            id: null,
          },
        },
        category: null,
        comments: null,
        contacts: [],
        description: null,
        legalNumber: null,
        legalName: null,
        name: null,
        schedule: [],
        type: 'Temporal',
        zone: [],
      },
      logService: null,
    };
  },
  created() {
    this.logService = Container.get(LogService);
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      await this.getSpotType();
      await this.getCountryList();
      if (this.selectedSpot) {
        this.spotForm.id = this.selectedSpot.id;
        this.spotForm.name = this.selectedSpot.name;
        this.spotForm.address = {
          id: this.selectedSpot.address.id,
          city: this.selectedSpot.address.city,
          addressComplement: this.selectedSpot.address.addressComplement,
          postalCode: this.selectedSpot.address.postalCode,
          state: this.selectedSpot.address.state,
          street: this.selectedSpot.address.street,
          lat: this.selectedSpot.address.lat,
          lon: this.selectedSpot.address.lon,
          country: {
            id: this.selectedSpot.address.country ? this.selectedSpot.address.country.id : null,
          },
        };
        this.spotForm.category = this.selectedSpot.category;
        this.spotForm.comments = this.selectedSpot.comments;
        this.spotForm.contacts = this.selectedSpot.contacts;
        this.spotForm.description = this.selectedSpot.description;
        this.spotForm.type = this.selectedSpot.type;
        this.spotTypeSelected = this.selectedSpot.type;

        const client = this.$store.getters.client;
        if (this.spotForm.type === 'Sede propia') {
          this.spotForm.legalNumber = client.legalNumber;
          this.spotForm.legalName = client.legalName;
        }
        this.countrySelected = this.selectedSpot.address.country;
        this.countrySelectedName = this.countrySelected ? this.countrySelected.name : null;

        const coordinates = {
          lat: this.spotForm.address.lat,
          lng: this.spotForm.address.lon,
        };
        this.$refs.map.setOneMarkerWZone(coordinates);
      }
      console.log('preparando modal');
    },
    clearSpotDataDetail() {
      this.spotForm.name = null;
      this.spotForm.legalName = null;
      this.spotForm.legalNumber = null;
      this.spotForm.type = null;
    },
    getCountryByIso(countryIso) {
      let countryMatched = null;
      this.countryList.forEach((element) => {
        if (countryIso === element.iso) {
          countryMatched = element;
        }
      });
      return countryMatched;
    },
    async receiveAddressInformation(addressInfo) {
      if (addressInfo.streetName !== '') {
        this.isInputUsed = true;
        console.log(addressInfo);
        this.countrySelected = addressInfo.iso.length === 0 ? '' : this.getCountryByIso(addressInfo.iso);
        this.countrySelectedName = this.countrySelected.name;
        this.spotForm.address.city = addressInfo.city;
        this.spotForm.address.state = addressInfo.state;
        this.spotForm.address.addressComplement = addressInfo.addressComplement;
        this.spotForm.address.street =
          addressInfo.number !== undefined ? addressInfo.streetName + ' ' + addressInfo.number : addressInfo.streetName;
        this.spotForm.address.lat = addressInfo.coordinates.lat;
        this.spotForm.address.lon = addressInfo.coordinates.lng;
        this.spotForm.address.country = {
          id: this.countrySelected.id,
        };
        if (this.spotForm.address.city) {
          this.isCityEmpty = false;
        } else {
          this.isCityEmpty = true;
        }
        if (this.spotForm.address.state) {
          this.isStateEmpty = false;
        } else {
          this.isStateEmpty = true;
        }

        const coordinates = {
          lat: this.spotForm.address.lat,
          lng: this.spotForm.address.lon,
        };
        this.$refs.map.setOneMarkerWZone(coordinates);
      } else {
        this.isInputUsed = false;
        this.isStateEmpty = false;
        this.isCityEmpty = false;
      }
    },
    closeModal() {
      this.$emit('closeSpotForm');
    },
    cleanSpotForm() {
      this.spotForm = {
        address: {
          city: null,
          postalCode: null,
          state: null,
          street: '',
          lat: null,
          lon: null,
          country: {
            id: null,
          },
        },
        category: null,
        comments: null,
        contacts: [],
        description: null,
        legalNumber: null,
        legalName: null,
        name: null,
        schedule: [],
        type: 'Temporal',
        zone: [],
      };
    },
    customRequiredState() {
      if (this.countrySelected !== null) {
        if (this.countrySelected.iso === 'CL') {
          return this.$t('spotForm.validaciones.requiredState');
        }

        if (this.countrySelected.iso === 'MX') {
          return this.$t('spotForm.validaciones.requiredStateMex');
        }
      }
      return this.$t('spotForm.validaciones.campoRequerido');
    },
    customRequiredCity() {
      if (this.countrySelected !== null) {
        if (this.countrySelected.iso === 'CL') {
          return this.$t('spotForm.validaciones.requiredCity');
        }

        if (this.countrySelected.iso === 'MX') {
          return this.$t('spotForm.validaciones.requiredCityMex');
        }
      }
      return this.$t('spotForm.validaciones.campoRequerido');
    },
    customForm(option) {
      if (option === 'state') {
        if (this.countrySelected !== null) {
          if (this.countrySelected.iso === 'CL') {
            return this.$t('spotForm.createSpot.region');
          }

          if (this.countrySelected.iso === 'MX') {
            return this.$t('spotForm.createSpot.delegation');
          }
        }
        return this.$t('spotForm.createSpot.state');
      }
      if (option === 'city') {
        if (this.countrySelected !== null) {
          if (this.countrySelected.iso === 'CL') {
            return this.$t('spotForm.createSpot.comuna');
          }

          if (this.countrySelected.iso === 'MX') {
            return this.$t('spotForm.createSpot.colony');
          }
        }
        return this.$t('spotForm.createSpot.city');
      }
    },
    validationSpot() {
      const isEmptyAddress = this.validateSpotAddress();
      const isEmptyCountry = this.validateSpotCountry();
      const isEmptyState = this.validateSpotState();
      const isEmptyCity = this.validateSpotCity();
      const isEmptyName = this.validateSpotName();
      const isEmptyType = this.validateSpotType();
      const isEmptyLegalNumber = this.validateSpotLegalNumber();
      return (
        isEmptyAddress &&
        isEmptyCountry &&
        isEmptyState &&
        isEmptyCity &&
        isEmptyName &&
        isEmptyType &&
        isEmptyLegalNumber
      );
    },
    validateSpotAddress() {
      const result = this.spotForm.address.street !== '';
      if (result) {
        this.checkFields.address = true;
        return true;
      } else {
        this.checkFields.address = false;
        this.showPopover('address');
        return false;
      }
    },
    validateSpotCountry() {
      const result = this.countrySelected !== null;
      if (result) {
        this.checkFields.country = true;
        this.hidePopover('country');
        return true;
      } else {
        this.checkFields.country = false;
        this.showPopover('country');
        return false;
      }
    },
    validateSpotState() {
      const result =
        this.spotForm.address.state !== undefined &&
        this.spotForm.address.state !== null &&
        this.spotForm.address.state !== '';
      if (result) {
        this.checkFields.state = true;
        this.isStateEmpty = false;
        this.hidePopover('state');
        return true;
      } else {
        this.checkFields.state = false;
        this.isStateEmpty = true;
        this.showPopover('state');
        return false;
      }
    },
    validateSpotCity() {
      const result =
        this.spotForm.address.city !== undefined &&
        this.spotForm.address.city !== null &&
        this.spotForm.address.city !== '';
      if (result) {
        this.checkFields.city = true;
        this.isCityEmpty = false;
        this.hidePopover('city');
        return true;
      } else {
        this.checkFields.city = false;
        this.isCityEmpty = true;
        this.showPopover('city');
        return false;
      }
    },
    validateSpotName() {
      const result = this.spotForm.name !== null;
      if (result) {
        this.checkFields.name = true;
        return true;
      } else {
        this.checkFields.name = false;
        this.showPopover('spotName');
        return false;
      }
    },
    validateSpotType() {
      const result = this.spotTypeSelected !== null;
      if (result) {
        this.checkFields.type = true;
        return true;
      } else {
        this.checkFields.type = false;
        this.showPopover('spotType');
        return false;
      }
    },
    validateSpotLegalNumber() {
      const result = this.spotForm.legalNumber !== null;
      if (result) {
        this.checkFields.numberId = true;
        this.hidePopover('spotId');
        return true;
      } else {
        this.checkFields.numberId = false;
        this.showPopover('spotId');
        return false;
      }
    },
    async createTemporalSpot() {
      this.isTemporalSpotBusy = true;
      let spot = null;
      if (this.validationSpot()) {
        await this.prepareSpotBody();
        if (this.selectedSpot) {
          spot = await this.updateSpot();
        } else {
          spot = await this.createSpot();
        }
        if (this.spotForm.type === 'Cliente' && spot !== null) {
          await this.createSpotBusiness(spot.id);
        }

        if (spot !== null) {
          spot.addressStreet = spot.address.street;
          this.optionSpots.push(spot);
          this.newDepot = this.optionSpots.find((destination) => spot.id === destination.id);
        }
      }
      this.isTemporalSpotBusy = false;
      if (spot !== null) {
        console.log('Nuevo depot ', this.newDepot);
        this.$emit('update-selected-depot', this.newDepot);
        this.closeModal();
        showAlert(
          this.$t('spotForm.createSpot.tituloExito'),
          this.$t('spotForm.createSpot.mensajeExitoCreacionSpot'),
          'success',
          undefined,
          undefined,
        );
      }
    },
    async updateSpot() {
      try {
        this.logService.sendInfo({
          component: 'spotForm',
          message: `updateSpot enviando a actualizar el spot ${this.spotForm.id}`,
          data: this.spotForm,
        });
        const url = `${this.$store.getters.urlAPI}/api/spot/${this.spotForm.id}`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.patch(url, this.spotForm, config);
        if (response.data.status) {
          return response.data.data;
        }
      } catch (error) {
        this.logService.sendError({
          component: 'spotForm',
          message: `updateSpot fallo en su procesamiento ${error.message}`,
        });
        this.isSaving = false;
        if (error.response.status === 500) {
          let rawJson = '' + error.response.data;

          //Se obtiene la hora en que ocurre el error.
          const eventTime = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss');

          //Se controla error en caso de que el nombre de la ubicacion ya exista.
          if (
            rawJson.includes(
              'ERROR: duplicate key value violates unique constraint "name_id_client_deleted_at_null_idx"',
            )
          ) {
            showAlert(
              'Error: ' + this.$t('spotForm.createSpot.nameSpot'),
              this.$t('spotForm.createSpot.spotDuplicated') + ' [' + eventTime + ']',
              'error',
            );
          }

          //Cualquier error no controlado
          showAlert(
            'Error ' + error.response.status,
            this.$t('spotForm.createSpot.spotUnexpectedError') + ' [' + eventTime + ']',
            'error',
          );
        }
        return null;
      }
    },
    async createSpot() {
      try {
        this.logService.sendInfo({
          component: 'spotForm',
          message: `createSpot procede a enviar el spot`,
          data: this.spotForm,
        });
        const url = `${this.$store.getters.urlAPI}/api/spot`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, this.spotForm, config);
        if (response.data.status) {
          return response.data.data;
        }
      } catch (error) {
        this.logService.sendError({
          component: 'spotForm',
          message: `createSpot fallo en su procesamiento ${error.message}`,
        });
        this.isSaving = false;

        if (error.response.status === 500) {
          let rawJson = '' + error.response.data;

          //Se obtiene la hora en que ocurre el error.
          const eventTime = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss');

          //Se controla error en caso de que el nombre de la ubicacion ya exista.
          if (
            rawJson.includes(
              'ERROR: duplicate key value violates unique constraint "name_id_client_deleted_at_null_idx"',
            )
          ) {
            showAlert(
              'Error: ' + this.$t('spotForm.createSpot.nameSpot'),
              this.$t('spotForm.createSpot.spotDuplicated') + ' [' + eventTime + ']',
              'error',
            );
          }

          //Cualquier error no controlado
          showAlert(
            'Error ' + error.response.status,
            this.$t('spotForm.createSpot.spotUnexpectedError') + ' [' + eventTime + ']',
            'error',
          );
        }
        return null;
      }
    },
    async createSpotBusiness(spotId) {
      try {
        const body = {
          idSpot: spotId,
          idBusiness: this.businessSelected.id,
          idClient: this.$store.getters.clientId,
        };
        this.logService.sendInfo({
          component: 'spotForm',
          message: `createSpotBusiness solicitando al back la creación /api/spot/spotBusiness`,
          data: body,
        });
        const url = `${this.$store.getters.urlAPI}/api/spot/spotBusiness`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, body, config);
        console.log(response.data.status);
      } catch (error) {
        this.logService.sendError({
          component: 'spotForm',
          message: `createSpotBusiness fallo en su procesamiento ${error.message}`,
        });
        console.log('error', error);
      }
    },
    async getSpotType() {
      const url = `${this.$store.getters.urlAPI}/api/enum?type=spot_type`;
      this.logService.sendInfo({
        component: 'spotForm',
        message: `getSpotType consultando a la api ${url}`,
      });
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(url, config);
        this.spotTypeList = response.data.data;
        const index = this.spotTypeList.indexOf('Temporal');
        if (index > -1) {
          this.spotTypeList.splice(index, 1);
        }
        if (this.dataAccess !== null && this.dataAccess.canNavPlanification && !this.dataAccess.canNavRouteBoard) {
          const index = this.spotTypeList.indexOf('Cliente');
          if (index > -1) {
            this.spotTypeList.splice(index, 1);
          }
        }
        console.log('Datos finales ', this.spotTypeList);
      } catch (error) {
        this.logService.sendError({
          component: 'spotForm',
          message: `getSpotType fallo ${error.message}`,
        });
        console.log(`${error}, Ha ocurrido un error.`);
      }
    },
    async getCountryList() {
      const url = `${this.$store.getters.urlAPI}/api/country`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const response = await axios.get(url, config);
      response.data.data.forEach((element) => {
        this.countryList.push({
          id: element.id,
          name: element.name,
          iso: element.iso,
        });
      });
      if (this.countryList.length > 0) {
        console.log('Listado de paises listo!');
        this.sortCountryList();
      } else {
        console.log('Listado de paises no listo. No se pueden crear ordenes!');
      }
    },
    sortCountryList() {
      this.countryList.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a y b son iguales.
        return 0;
      });
    },
    async prepareSpotBody() {
      this.spotForm.address.city = this.spotForm.address.city ? this.spotForm.address.city : ' ';
      this.spotForm.address.state = this.spotForm.address.state ? this.spotForm.address.state : ' ';
      this.spotForm.zone = [
        {
          lat: this.spotForm.address.lat,
          lon: this.spotForm.address.lon,
          radio: 100,
        },
      ];
    },
    checkClientSpot() {
      this.spotForm.legalName = null;
      this.spotForm.legalNumber = null;

      const client = this.$store.getters.client;

      this.spotForm.type = this.spotTypeSelected;

      if (this.spotForm.type === 'Sede propia') {
        this.spotForm.legalNumber = client.legalNumber;
        this.spotForm.legalName = client.legalName;
      } else if (this.spotForm.type === 'Cliente') {
        this.spotForm.legalNumber = null;
        this.spotForm.legalName = null;
        this.businessSelected = null;
        this.getBusinessList();
      } else if (this.spotForm.type === 'Otro') {
        this.spotForm.legalName = client.legalName;
      }
    },
    async getBusinessList() {
      this.isLoadingBusiness = true;
      const url = `${this.$store.getters.urlAPI}/api/business/`;
      this.logService.sendInfo({
        component: 'spotForm',
        message: `getBusinessList consultando a la api ${url}`,
      });
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(url, config);
        this.businessList = response.data.data;
      } catch (error) {
        this.logService.sendError({
          component: 'spotForm',
          message: `getBusinessList fallo ${error.message}`,
        });
        console.log(`${error}, Ha ocurrido un error.`);
      }
    },
    setBusiness() {
      this.spotForm.legalNumber = this.businessSelected.legalNumber;
      this.spotForm.legalName = this.businessSelected.legalName;
    },
    showPopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    hideError(originalReference) {
      if (originalReference === this.errorReference) {
        this.errorReference = null;
      }
    },
  },
  computed: {
    isNewMapEnabled() {
      const feature = this.$feature('newComponent');
      console.log('El nuevo fgeature esta activo ', feature);
      return feature && this.$store.getters.clientId == 161;
    },
  },
};
